import { Assort } from "../../../models/Assort";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import {GET_GIFT_CARD } from "../../../api/apiRoutes";


export default function useGiftCard() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();

  const [tickets, setTickets] = useState<Assort[]>([]);


  const acceptTransaction = async () => {
    const { result, isError } = await get(GET_GIFT_CARD(facilityIds));
    if (!isError) {
      setTickets(result)
    }
  };
  

  return {
    acceptTransaction,
    tickets,
  };
}
